export enum articlesSubmitTypes {
  FETCH_ARTICLES_SUBMIT_REQUEST = "FETCH_ARTICLES_SUBMIT_REQUEST",
  FETCH_ARTICLES_SUBMIT_SUCCESS = "FETCH_ARTICLES_SUBMIT_SUCCESS",
  FETCH_ARTICLES_SUBMIT_FAILURE = "FETCH_ARTICLES_SUBMIT_FAILURE",
}